import { __ } from '@wordpress/i18n';
import {
    useBlockProps,
    MediaUpload,
    MediaUploadCheck,
    InspectorControls
} from '@wordpress/block-editor';

import {
    PanelBody,
    Button,
    RangeControl,
    ToggleControl
} from '@wordpress/components';

import './editor.scss';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export default function Edit({ attributes, setAttributes }) {
    const {
        images,
        slidesPerView,
        speed,
        autoplay,
        loop,
        navigation,
        pagination
    } = attributes;

    const onSelectImages = (newImages) => {
        setAttributes({
            images: newImages.map((img) => ({
                id: img.id,
                url: img.url,
                alt: img.alt
            }))
        });
    };

    return (
        <div {...useBlockProps({ className: 'custom-slider' })}>
            <InspectorControls>

                <PanelBody
                    title={__('Slider Settings', 'pixelnest-blocks')}
                    initialOpen={true}
                >
                    <MediaUploadCheck>
                        <MediaUpload
                            onSelect={onSelectImages}
                            allowedTypes={['image']}
                            multiple
                            value={images?.map((img) => img.id)}
                            render={({ open }) => (
                                <Button onClick={open} variant="primary">
                                    {__('Add Slides', 'pixelnest-blocks')}
                                </Button>
                            )}
                        />
                    </MediaUploadCheck>

                    <RangeControl
                        label={__('Slides per view', 'pixelnest-blocks')}
                        value={slidesPerView}
                        onChange={(value) =>
                            setAttributes({ slidesPerView: value })
                        }
                        min={1}
                        max={5}
                        __next40pxDefaultSize
                        __nextHasNoMarginBottom
                    />

                    <RangeControl
                        label={__('Autoplay Speed (ms)', 'pixelnest-blocks')}
                        value={speed}
                        onChange={(value) =>
                            setAttributes({ speed: value })
                        }
                        min={1000}
                        max={10000}
                        step={500}
                        __next40pxDefaultSize
                        __nextHasNoMarginBottom
                    />

                    <ToggleControl
                        label={__('Enable Autoplay', 'pixelnest-blocks')}
                        checked={autoplay}
                        onChange={(value) =>
                            setAttributes({ autoplay: value })
                        }
                        __nextHasNoMarginBottom
                    />

                    <ToggleControl
                        label={__('Enable Loop', 'pixelnest-blocks')}
                        checked={loop}
                        onChange={(value) =>
                            setAttributes({ loop: value })
                        }
                        __nextHasNoMarginBottom
                    />

                    <ToggleControl
                        label={__('Show Navigation Arrows', 'pixelnest-blocks')}
                        checked={navigation}
                        onChange={(value) =>
                            setAttributes({ navigation: value })
                        }
                        __nextHasNoMarginBottom
                    />

                    <ToggleControl
                        label={__('Show Pagination Dots', 'pixelnest-blocks')}
                        checked={pagination}
                        onChange={(value) =>
                            setAttributes({ pagination: value })
                        }
                        __nextHasNoMarginBottom
                    />
                </PanelBody>

            </InspectorControls>

            {images?.length ? (
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    slidesPerView={slidesPerView}
                    loop={loop}
                    navigation={navigation}
                    pagination={pagination ? { clickable: true } : false}
                    autoplay={autoplay ? { delay: speed } : false}
                    spaceBetween={10}
                >
                    {images.map((img) => (
                        <SwiperSlide key={img.id}>
                            <img src={img.url} alt={img.alt} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <p>{__('No images selected yet.', 'pixelnest-blocks')}</p>
            )}
        </div>
    );
} 
